import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const names = ['Martín', 'Sofía', 'Lucas', 'Valentina', 'Mateo', 'Camila', 'Juan', 'Lucía', 'Nicolás', 'Martina'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 4000);
    // Loop with random interval between 8-15 seconds + 5s display time
    const loop = () => {
      const randomInterval = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(() => {
        showNotification();
        loop();
      }, randomInterval + 5000);
    };
    loop();
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-226">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-lg p-4 flex items-center gap-3 border-l-4 border-green-500 max-w-xs" data-id="element-227">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-228">
            <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-229" />
          </div>
          <div data-id="element-230">
            <p className="text-sm font-bold text-gray-800" data-id="element-231">¡Nueva compra!</p>
            <p className="text-xs text-gray-600" data-id="element-232">
              <span className="font-semibold" data-id="element-233">{notification.name}</span> de{' '}
              {notification.city} compró el Kit.
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-234">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}